import styled from 'styled-components';

export const TrustSection = styled.section`
  margin: 30px 0;
  padding: 30px 0;
  background-color: hsl(190deg 67% 92% / 26%);
`;

export const CenterDiv = styled.div`
  width: 100%;
  max-width: 85%;
  margin: auto;

  @media (max-width: 720px) {
    max-width: 100%;
  }
`;

export const Title = styled.h2`
  font-weight: 500;
  text-transform: uppercase;
  text-align: center;
  letter-spacing: 2.2px;
  font-size: clamp(18px, 3vw, 22px);
  color: hsl(0deg, 0%, 0%, 87%);
`;

export const TrustGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 24%);
  grid-gap: 17px;
  margin: 30px 0;
  justify-content: center;

  @media (max-width: 720px) {
    grid-template-columns: repeat(2, 46%);
  }
  .transitionClass {
    transition: all 0.2s ease-in-out;
  }
  .gridcardopacity {
    opacity: 0.5;
  }
`;

export const TitleNumberDiv = styled.div`
  background: hsl(0deg 0% 100% / 45%);
  width: max-content;
  margin: auto;
  padding: 16px 20px;
  @media (min-width: 720px) {
    cursor: pointer;
  }
`;

export const TrustNumber = styled.strong`
  display: block;
  color: hsl(0deg, 0%, 0%, 87%);
  text-align: center;
  font-size: clamp(16px, 3vw, 24px);

  .star_image {
    width: 20px;
    height: 20px;
    margin-left: 4px;

    @media (max-width: 720px) {
      width: 16px;
      height: 16px;
      margin-top: 1px;
    }
  }
`;

export const TrustTitle = styled.span`
  display: block;
  text-transform: uppercase;
  text-align: center;
  font-size: clamp(11px, 2vw, 14px);
  font-weight: 500;
  color: rgb(0 0 0 / 42%);
  padding-top: 2px;
`;

export const WhyParentingContent = styled.div`
  width: 250px;
  background: #fff;
  padding: 8px 16px;
  margin: auto;
  text-align: center;
  font-weight: 600;
  color: hsl(0deg, 0%, 0%, 50%);
  font-size: clamp(10px, 2vw, 14px);
  letter-spacing: 1px;

  @media (max-width: 720px) {
    width: max-content;
    padding: 8px 10px;
  }
`;

export const HeadingSeoSection = styled.section`
  padding: 16px 2.5%;
  margin: 16px 0 0;

  @media (max-width: 720px) {
    padding: 16px 10px 0;
  }

  .readMore {
    color: #63b0a8;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.15s ease;

    &:hover {
      text-decoration: underline;

      @media (max-width: 720px) {
        text-decoration: none;
      }
    }

    @media (max-width: 720px) {
      cursor: default;
    }
  }
`;
export const MainPageTitle = styled.h1`
  color: hsl(0deg, 0%, 0%, 80%);
  font-size: clamp(20px, 2vw, 24px);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 5px;
  text-align: center;
  padding-bottom: clamp(10px, 2vw, 16px);
  @media (max-width: 720px) {
    letter-spacing: 3px;
    line-height: 32px;
  }
`;

export const SeoContent = styled.p`
  font-size: clamp(0.875rem, 0.838rem + 0.19vw, 1rem);
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 80%);
  line-height: 23px;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  transition: all 0.2s ease;
  height: 92px;

  &.fullContent {
    -webkit-line-clamp: inherit;
    transition: all 0.2s ease;
    height: auto;
  }
`;
